/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';
import getSchema from "../../lib/api/getSchema";
import notificationState from "../../states/notificationState";
import { useSetRecoilState } from "recoil";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";
import DeleteRecordButton from "../input/DeleteRecordButton";
import CreateRecordButton from "../input/CreateRecordButton";
import defineConf from "../../config/defineConf";

function MomSysUglOrderBuyerDetailFiles ( props ) {

    const {
        id,
        view,
        onSelectMst,
        onSelectDetail,
    } = props;

    const { t } = useTranslation();

    const setNotification = useSetRecoilState(notificationState);

    const [ grid, setGrid ] = useState();

    const [ api, setApi ] = useState();

    const [ schema, setSchema ] = useState();

    const [isEmpty, setIsEmpty] = useState();

    useEffect(() => {

        let mounted = true;

        (async () => {

            let schema = await getSchema(id);

            if ( mounted ) {
                setSchema(schema);
            }

        })();

        return ( () => {
            mounted = false;
        } );

    }, []);

    useEffect ( ( ) => {

        if ( api ) {

            api.refresh();

        }

        if ( schema ) {
            
            for (const column of schema.columns) {
        
                switch (column.name) {
    
                case "orderBuyerDetailId":
    
                    column.defaultValue = onSelectDetail.orderBuyerDetailId;
                    column.disabled = true;
    
                    break;
    
                default:
    
                    break;
                }
            }
            
            setSchema(schema);

        }

    }, [api, onSelectDetail.orderBuyerDetailId, schema] )

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onSuccess = (msg) => {

        notifySuccess(msg);

    };

    const notifyFailure = (msg) => {

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onFailure = (reason) => {

        notifyFailure(reason.response ? reason.response.data : reason);

    };

    const notifyWarning = (msg) => {

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const onNotifyWarning = (msg) => {

        notifyWarning(msg);

    };


    const onApiInitialized = ( api ) => {

        setApi(api);

    };
    
    const onInitialized = grid => {

        setGrid(grid);

    };

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    }

    const onModifyViewUrl = ( url, orderBuyerDetailId ) => {

        return url + "/" + orderBuyerDetailId;

    };

    return (

        <BasicCrudScreenType
            id={id}
            headerTitle={ t(`term.${id}`) }
            view={view}
            onInitialized={onInitialized}
            onApiInitialized={onApiInitialized}
            onModifyViewUrl={ ( url ) => onModifyViewUrl ( url, onSelectDetail?.orderBuyerDetailId ) }
            onLoadData={onLoadData}
            noEdit
            noExcel
            noFilter
            noPagination
            onAppendButtonInFrontOfSearch={
                () => (
                    <>
                        <BasicCrudScreenActionItemLayout>
                            <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                                <CreateRecordButton
                                    id={id}
                                    schema={schema}
                                    refresh={api}
                                    onSuccess={onSuccess}
                                    disabled={([defineConf.approvalState.REJECTED, defineConf.approvalState.WITHDRAWN, defineConf.approvalState.CANCELLED].includes(onSelectMst?.approvalState)) || !onSelectDetail?.orderBuyerDetailId || onSelectDetail?.standard}
                                />
                            </AccessControl>

                            <AccessControl accessTarget={schema && schema.name} accessMethod="DELETE">
                                <DeleteRecordButton
                                    id={id}
                                    schema={schema}
                                    grid={grid}
                                    refresh={api}
                                    color="secondary"
                                    onSuccess={onSuccess}
                                    onFailure={onFailure}
                                    onPartialFailure={onNotifyWarning}
                                    disabled={([defineConf.approvalState.REJECTED, defineConf.approvalState.WITHDRAWN, defineConf.approvalState.CANCELLED].includes(onSelectMst?.approvalState)) || !onSelectDetail?.orderBuyerDetailId || isEmpty}
                                />
                            </AccessControl>

                        </BasicCrudScreenActionItemLayout>
                    </>
                )
            }
        />

    );

}

export default MomSysUglOrderBuyerDetailFiles;
